import { createContext, useContext } from 'react';

const FormControlContext = createContext({
  isRequired: false,
  isInvalid: false,
  isValid: false,
  isDisabled: false,
  isReadOnly: false
});
const useFormControlContext = () => {
  const context = useContext(FormControlContext);
  return context;
};
const useFormControl = (props) => {
  const context = useFormControlContext();
  if (!context) {
    return props;
  }
  const keys = Object.keys(context);
  return keys.reduce((acc, prop) => {
    acc[prop] = props[prop];
    if (context && !props[prop]) {
      acc[prop] = context[prop];
    }
    return acc;
  }, {});
};

export { FormControlContext, useFormControl, useFormControlContext };
//# sourceMappingURL=FormControlContext.es.js.map
